module.exports = __webpack_public_path__ + "groupings.88ee1fca967cfe10502f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/groupings.svg
// module id = ./src/assets/img/groupings.svg
// module chunks = main